/**
 * Allowed {@code workflowType} values for registration requests — keep in sync with
 * server {@code WorkflowType.IsValid} (values {@code registration}, {@code linkaccount}).
 */
export const WORKFLOW_TYPE_REGISTRATION = 'registration';
export const WORKFLOW_TYPE_LINK_ACCOUNT = 'linkaccount';

const ALLOWED_REGISTRATION_WORKFLOW_TYPES = new Set([
  WORKFLOW_TYPE_REGISTRATION,
  WORKFLOW_TYPE_LINK_ACCOUNT,
]);

/**
 * Normalizes legacy UI state (e.g. in-flight history entries) to {@link WORKFLOW_TYPE_LINK_ACCOUNT}.
 * @param {string|undefined} value
 * @returns {string|undefined}
 */
export function normalizeRegistrationWorkflowType(value) {
  if (value === 'LinkAccount') {
    return WORKFLOW_TYPE_LINK_ACCOUNT;
  }
  return value;
}

/**
 * Returns a registration {@code workflowType} the server accepts, or {@code undefined} to omit it.
 * UI-only labels (e.g. {@code NewRegistration}) are filtered out; result is lowercased.
 * @param {string|undefined|null} workflowType
 * @returns {string|undefined}
 */
export function allowedRegistrationWorkflowType(workflowType) {
  if (workflowType == null || workflowType === '') {
    return undefined;
  }
  const key = String(workflowType).toLowerCase();
  if (!ALLOWED_REGISTRATION_WORKFLOW_TYPES.has(key)) {
    return undefined;
  }
  return key;
}
